export const DAM_APP_NAME = 'piivo_portal_application_dam';

/**
 * Namespace for all dam services
 */
export const DAM_SERVICES_NAMESPACE = 'dam';
